import { memo } from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";


const BzPopoverOverlay = ({ rootClose, trigger, placement = 'right', popover, onToggle, show, ...props }) => {

    return (

        <OverlayTrigger {...props} trigger={trigger} placement={placement} overlay={popover} rootClose={rootClose} onToggle={onToggle} show={show}>
            {props.children}
        </OverlayTrigger>
    );
};

export default memo(BzPopoverOverlay);


BzPopoverOverlay.propTypes = {
    trigger: PropTypes.string,
    placement: PropTypes.string,
    popover: PropTypes.element,
    rootClose: PropTypes.bool,
    onToggle: PropTypes.func,
    show: PropTypes.bool

};

BzPopoverOverlay.defaultProps = {
    placement: "auto"
};
